/**
 * @prop --show-display: Display value that is used when content is shown (default `block`)
 * @prop --hide-display: Display value that is used when content is hidden (default `none`)
 * @prop --current-display: Current display value (readonly)
 */

:host {
  --show-display: contents;
  --hide-display: none;
  --current-display: var(--hide-display);

  display: var(--current-display);
}

/* Mikro */

:host([mikro]) {
  --current-display: var(--show-display);
}

:host([mikro="false"]) {
  --current-display: var(--hide-display);
}

/* Small */

:host([small]) {
  @include mq($from: small) {
    --current-display: var(--show-display);
  }
}

:host([small="false"]) {
  @include mq($from: small) {
    --current-display: var(--hide-display);
  }
}

/* Medium */

:host([medium]) {
  @include mq($from: medium) {
    --current-display: var(--show-display);
  }
}

:host([medium="false"]) {
  @include mq($from: medium) {
    --current-display: var(--hide-display);
  }
}

/* Large */

:host([large]) {
  @include mq($from: large) {
    --current-display: var(--show-display);
  }
}

:host([large="false"]) {
  @include mq($from: large) {
    --current-display: var(--hide-display);
  }
}

/* Ultra */

:host([ultra]) {
  @include mq($from: ultra) {
    --current-display: var(--show-display);
  }
}

:host([ultra="false"]) {
  @include mq($from: ultra) {
    --current-display: var(--hide-display);
  }
}